<template>
  <a
    class="a-avatar-primary a-avatar-link-primary a-avatar-medium"
    href="#"
    @click.stop.prevent="click()"
  >
    <img
      v-if="avatarPrimary.image.length"
      key="avatarPrimaryImage"
      :src="avatarPrimary.image"
    >
    <img
      v-else
      key="defaultImage"
      src="@/assets/img/avatar.png"
    >
  </a>
</template>

<script>
export default {
  name: 'AtomAvatarPrimary',

  props: {
    avatarPrimary: Object
  },

  methods: {
    click () {
      this.$emit(this.avatarPrimary.method, this.avatarPrimary.component)
    }
  }
}
</script>
